export const PASSWORD_EXPIRATION_DAYS_WARNING = 5
